module.exports = __webpack_public_path__ + "media/images/emblems/Rougemont-coat_of_arms-c206ca3b9e20b543683966e068b5f590.svg";